// X scores arrive as sentinel values in xes_by_hole (see XScoreTransformer):
// -2 (or true) is a plain X, -101..-109 encode X1..X9.
const X_PLAIN = -2;
const X_NUMBERED_MAX = -101;
const X_NUMBERED_MIN = -109;

const isPlainX = (value) => value === true || value === X_PLAIN;

const isNumberedX = (value) =>
  typeof value === 'number' && value >= X_NUMBERED_MIN && value <= X_NUMBERED_MAX;

export const applyXesByHole = (strokes, xesByHole) => {
  if (!strokes?.length) return strokes ?? [];

  return strokes.map((stroke, index) => {
    if (stroke) return stroke;

    const xValue = xesByHole?.[index];
    if (isPlainX(xValue)) return 'X';
    if (isNumberedX(xValue)) return `X${-(100 + xValue)}`;
    // No strokes and no X sentinel (both arrays 0) — blank cell.
    return '';
  });
};
